/* @ngInject */
function ReadersSliderController ($scope, $rootScope, SliderService) {
  $scope.sliderClass = 'readers-slider'

  $scope.$watch('$$childHead', function () {
    if ($scope.$$childHead) {
      $scope.setOpenSettings({ left: '0' }, 400)
      $scope.setCloseSettings({ left: '-100%' }, 400)

      SliderService.register($scope.sliderClass)
      SliderService.registerState($scope.sliderClass, 'open', function (data) {
        const content = $scope.$$childHead

        content.getPostReaders(data.post.id)
        content.post = data.post
        $scope._postId = data.postId

        $scope.setSliderOpen(true)
      })

      SliderService.registerState($scope.sliderClass, 'close', function () {
        $scope.setSliderOpen(false)
      })

      $scope.isUserSysAdminAdminDesigner = $rootScope.isUserSysAdminAdminDesigner
    }
  })
}

export { ReadersSliderController }
